import { Base64 } from 'js-base64'
import { env } from '../../utils/utils'

export function redirectLogin() {
  location.href = `${env.ssoBaseUrl}/login?next=${Base64.encode(location.href)}`
}

export function redirectLogout() {
  window.location.href = `${env.ssoBaseUrl}/logout?next=${window.location.href}`
}
